import { Fragment } from "react";
import { langugae } from "../../../../config/languageJSON";
import {
  displayAmount,
  displayQty,
  findOrderSummary,
  getCategoryTotals,
  getFinalTotals,
} from "../utils/productWiseSkuPdfUtils";
import {
  collapseFullWidth,
  columnHeaderRow,
  finalTotalRow,
  summaryFont,
  summaryLabel,
  tbodyFullWidth,
  tdBoldBorderRight,
  tdBorderRight,
  tdLeftBold,
  tdLeftBordered,
  thBorderRight,
  thProduct,
} from "../styles/productWiseSkuPdfStyles";

// Shared SKU table. Pass getUomQty + getProductAllQty for feature-specific math.
const ProductWiseSkuPdfTable = ({
  billList,
  dateLabel,
  categoryWithProducts,
  uomList,
  orderSummaries,
  getUomQty,
  getProductAllQty,
}) => {
  const colCount = uomList.length + 2;
  const finalTotal = getFinalTotals({
    categoryWithProducts,
    uomList,
    orderSummaries,
    getUomQty,
    getProductAllQty,
  });

  const uomHeaderCells = [];
  for (let i = 0; i < uomList.length; i++) {
    const uom = uomList[i];
    uomHeaderCells.push(
      <th key={uom.id} className="thsmallcell" style={thBorderRight}>
        {uom.name}
      </th>
    );
  }

  const bodyRows = [];
  for (let c = 0; c < categoryWithProducts.length; c++) {
    const categoryData = categoryWithProducts[c];
    const category = categoryData.category;
    const products =
      categoryData.products != null ? categoryData.products : [];
    const categoryTotals = getCategoryTotals({
      categoryData,
      uomList,
      orderSummaries,
      getUomQty,
      getProductAllQty,
    });

    const emptyUomCells = [];
    for (let u = 0; u < uomList.length; u++) {
      emptyUomCells.push(
        <td
          key={uomList[u].id}
          style={tdBorderRight}
          className="tdsmallcell"
        ></td>
      );
    }

    const productRows = [];
    for (let p = 0; p < products.length; p++) {
      const product = products[p];
      const allQty = getProductAllQty(product, uomList, orderSummaries);

      const productUomCells = [];
      for (let u = 0; u < uomList.length; u++) {
        const uom = uomList[u];
        const summary = findOrderSummary(
          orderSummaries,
          product.id,
          uom.id
        );
        const uomQty = getUomQty(summary);
        productUomCells.push(
          <td
            key={uom.id}
            align={"right"}
            style={tdBorderRight}
            className="tdsmallcell"
          >
            {displayQty(uomQty)}
          </td>
        );
      }

      productRows.push(
        <tr key={product.id}>
          <td align={"left"} style={tdLeftBordered} className="tdsmallcell">
            {product.name}
          </td>
          {productUomCells}
          <td align={"right"} style={tdBorderRight} className="tdsmallcell">
            {displayQty(allQty)}
          </td>
        </tr>
      );
    }

    const categoryTotalUomCells = [];
    for (let u = 0; u < uomList.length; u++) {
      const uom = uomList[u];
      categoryTotalUomCells.push(
        <td
          key={uom.id}
          align={"right"}
          style={tdBoldBorderRight}
          className="tdsmallcell"
        >
          {displayQty(categoryTotals[uom.id])}
        </td>
      );
    }

    bodyRows.push(
      <Fragment key={"cat-block-" + category.id}>
        <tr>
          <td align={"left"} style={tdLeftBold} className="tdsmallcell">
            {category.name + " ( " + category.shortName + " ) "}
          </td>
          {emptyUomCells}
          <td style={tdBorderRight} className="tdsmallcell"></td>
        </tr>
        {productRows}
        <tr>
          <td align={"left"} style={tdLeftBold} className="tdsmallcell">
            {langugae[2].total ? langugae[2].total : ""}
          </td>
          {categoryTotalUomCells}
          <td
            align={"right"}
            style={tdBoldBorderRight}
            className="tdsmallcell"
          >
            {displayQty(categoryTotals.all)}
          </td>
        </tr>
      </Fragment>
    );
  }

  const finalTotalUomCells = [];
  for (let u = 0; u < uomList.length; u++) {
    const uom = uomList[u];
    finalTotalUomCells.push(
      <td
        key={uom.id}
        align={"right"}
        style={tdBoldBorderRight}
        className="tdsmallcell"
      >
        {displayQty(finalTotal[uom.id])}
      </td>
    );
  }

  return (
    <table style={collapseFullWidth}>
      <thead>
        <tr>
          <td colSpan={colCount}>
            <table style={collapseFullWidth}>
              <tr>
                <td>
                  <div style={summaryFont}>
                    <div style={summaryLabel}>
                      {langugae[2].amount
                        ? langugae[2].amount + " : "
                        : ""}
                    </div>{" "}
                    {displayAmount(billList.amt)}
                  </div>
                </td>
                <td align={"right"}>
                  <div style={summaryFont}>
                    <div style={summaryLabel}>
                      {langugae[2].date ? langugae[2].date + " : " : ""}
                    </div>
                    {dateLabel}
                  </div>
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr style={columnHeaderRow}>
          <th className="thsmallcell" style={thProduct}>
            {langugae[2].productName ? langugae[2].productName : ""}
          </th>
          {uomHeaderCells}
          <th className="thsmallcell" style={thBorderRight}>
            {langugae[2].all ? langugae[2].all : "All"}
          </th>
        </tr>
      </thead>

      <tbody style={tbodyFullWidth}>
        {bodyRows}
        <tr style={finalTotalRow}>
          <td align={"left"} style={tdLeftBold} className="tdsmallcell">
            {langugae[2].finalTotal ? langugae[2].finalTotal : ""}
          </td>
          {finalTotalUomCells}
          <td
            align={"right"}
            style={tdBoldBorderRight}
            className="tdsmallcell"
          >
            {displayQty(finalTotal.all)}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default ProductWiseSkuPdfTable;
